import React, { Component } from 'react';
import * as CoreHelper from '../../../common/coreHelper';
import * as AnalyticsHelper from '../../../common/AnalyticsSvc';
import * as Utils from '../../../common/utilSvc';
import * as DbUtils from '../../../common/DbSvc';
import { isNullOrUndefined } from "util";
import firebase from "firebase/app";
import "firebase/analytics";
import './individualPoint.css';
import { Button } from '@material-ui/core';

class IndividualPoint extends React.Component {

    constructor(props){
        super(props);
        //Point

        this.state = {
            unselectedKeyWords: {}
        }

        this.renderKeyWord = this.renderKeyWord.bind(this);
        this.selectKeyword = this.selectKeyword.bind(this);
        this.getIconsForKeywords = this.getIconsForKeywords.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.clickImage = this.clickImage.bind(this);
        this.downloadSvgIcon = this.downloadSvgIcon.bind(this);
    }

    selectKeyword(keyword){
        let unselectedKeyWords = this.state.unselectedKeyWords;
        if(keyword in unselectedKeyWords){
            delete unselectedKeyWords[keyword];            
        }
        else{
            unselectedKeyWords[keyword] = keyword;
        }
        this.setState({unselectedKeyWords: unselectedKeyWords})
    }

    renderKeyWord(keyword){
        let scope = this;
        return (
            <div className={'pointKeyword ' + (keyword in this.state.unselectedKeyWords? 'unselected-pointKeyword':'selected-pointKeyword')}  
            onClick={() => {scope.selectKeyword(keyword)}}>
                {keyword}
            </div>
        )
    }

    getIconsForKeywords(keywordList, unselectedKeyWords){
        if(isNullOrUndefined(this.props.iconListMap) || isNullOrUndefined(keywordList))
            return {};
        let iconListMap = this.props.iconListMap;

        let iconList = [];
        let iconMap = {}
        // console.log(keywordList);
        for(let i=0;i<keywordList.length; i++){
            if(!(keywordList[i]["name"] in unselectedKeyWords) && 
            keywordList[i]["name"] in iconListMap){
                let keywordIcons = iconListMap[keywordList[i]["name"]];
                for(let j=0; j<keywordIcons.length; j++){
                    iconMap[keywordIcons[j]['preview_url']] = keywordIcons[j];
                }
            }
        }

        for (let key in iconMap){
            iconList.push(iconMap[key]);
        }

        return iconList;
    }

    clickImage(url){
        if(!isNullOrUndefined(url)){
            firebase.analytics().logEvent('icon_clicked',{
                'url': url
            });
            window.open(url,"_blank")
        }
    }

    renderIcon(icon){

        if(isNullOrUndefined(icon) || !('preview_url' in icon)){
            return null;
        }

        // console.log(icon);

        let url = null;
        if('id' in icon && "api_src" in icon && icon['api_src']=='iconfinder'){
            url = "https://www.iconfinder.com/icons/"+icon['id']
        }
        else if('id' in icon && "term_slug" in icon && "api_src" in icon && icon['api_src']=='nounproj')
        {
            url = "https://thenounproject.com/icon/"+icon['term_slug']+"-"+icon['id'];
        }

        let scope = this;

        return (
            <div>
                <div>
                    <img 
                        // src="//upload.wikimedia.org/wikipedia/commons/thumb/8/80/Roblox_Logo_Black.svg/220px-Roblox_Logo_Black.svg.png"
                        onClick={() => scope.clickImage(url)}
                        src={icon['preview_url']}
                        style={{cursor:'pointer', maxWidth:"56px", maxHeight:"56px", 
                        border:'0.5px darkgrey solid', margin:'0.5em', marginLeft:'0px'}}>                    
                    </img>
                </div>
                {this.props.hideDownload?
                    null
                    :
                <div style={{textAlign:'center'}}>
                    <Button 
                    style={{maxWidth:"56px", marginBottom:'0.5em', fontSize:'8px'}}
                    onClick={() => {scope.downloadSvgIcon(icon)}}>Download</Button>
                </div>
                }                
            </div>
        )
    }

    async downloadSvgIcon(icon){
        if(!isNullOrUndefined(icon) && icon['api_src']=='iconfinder' && ('svg_download' in icon)){

            let id = icon['id'];
            let icn_query = "";
            if('query' in icon)
                icn_query = icon['query']+"_";

            let urlNew = "https://www.iconfinder.com/icons/"+icon['id']
            //Add to excel
            let row = {
                userId: "123", // need dummy value here
                icon_link: urlNew,
                search_term: icn_query.replace("_"," "),
                date: Utils.formatDate(Date.now(), true),
                ts: Date.now()
            }
            // console.log(row)
            await AnalyticsHelper.logIconDownloadInExcel(row);
        

            // this.logIconDownload(icon,icn_query);

            let url = await DbUtils.getIconUrlFromDb('iconfinder',icon.id);
            // console.log(url);
            if(!isNullOrUndefined(url)){
                const element = document.createElement("a");
                element.href = url;
                element.download = icn_query + "icon.svg";
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();
            }
            else{

                url = icon['svg_download'];
                // console.log(url);
                let output = await CoreHelper.downloadIconfinderIcon(url);
                // console.log(output);

                const element = document.createElement("a");
                const file = new Blob([output], {type: 'text/plain'});
                element.href = URL.createObjectURL(file);
                
                element.download = icn_query + "icon.svg";
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();

                //Write to db
                DbUtils.writeIconToDb(File,'iconfinder',icon.id)
            }
           
                
        }
    }

    async logIconDownload(icon, icn_query){
        let urlNew = "https://www.iconfinder.com/icons/"+icon['id']
        //Add to excel
        let row = {
            userId: "123", // need dummy value here
            icon_link: urlNew,
            search_term: icn_query.replace("_"," "),
            date: Utils.formatDate(Date.now(), true),
            ts: Date.now()
        }
        // console.log(row)
        AnalyticsHelper.logIconDownloadInExcel(row);
    }

    render(){

        let scope = this;

        const keywordsRender = this.props.point["keywords"].map((keyword) => 
                    { 
                        return (
                            scope.renderKeyWord(keyword['name'])                    
                        )
                    });
        let icons = [];
        icons = scope.getIconsForKeywords(this.props.point["keywords"], this.state.unselectedKeyWords);
        // console.log(icons);

        const iconsRender = icons.map((icon) => 
        {
            return (
                scope.renderIcon(icon)
            )
        });

        return (
            <div style={{margin:'1em', marginBottom:'2em'}}>
                <p>
                    {this.props.point['text']}
                </p>
                <div style={{display:'flex', flexWrap:'wrap'}}>
                    {keywordsRender}
                </div>
                <div className={"iconrender "+(this.props.unlimitedScrollIcon? "":"maxHeight-300")} style={{}}>
                    <div style={{display:'flex', flexWrap:'wrap'}}>
                        {iconsRender}
                    </div>
                </div>

            </div>
        )
    }
}
export default IndividualPoint;